<template>
<div class="page">
    <!-- 顶部 -->
    <!-- 下拉面板 -->
    <header class="header">
        <a href="javascript:;" class="goBack" @click="goBack()"></a>
        <h3>排行榜</h3>
    </header>
    <!-- tab页面 -->
    <div class="auctionList">
        <van-tabs v-model="num" @change="changeTab">
            <template v-for="(item,i) in rankMenu">
                <van-tab :key="i" :title="item.title" :name="i">

                    <template v-if="num==0">
                        <div class="listBox" v-for="(itemSingle,k) in rankSingle" @click="jumpLot(itemSingle)" :key="k+'rankSingle'">
                            <div class="imgBox">
                                <img :src="itemSingle.coverPic">
                                <div class="topClasss" :class="'top'+(k+1)">TOP{{k+1 }}</div>
                            </div>
                            <div class="textBox">
                                <div class="titleBox">{{ itemSingle.show_title }}</div>
                                <div class="descBox">{{ itemSingle.date }}</div>
                                <div class="descBox" style="margin-top:0.7rem">{{ itemSingle.company }}</div>
                                <template v-if="isMem ==1">
                                    <div class="descBox"><i v-if="itemSingle.price.smallText">{{itemSingle.price.smallText+' '}}</i><span>{{itemSingle.price.text}}</span></div>
                                </template>
                                <template v-else>
                                    <div class="descBox"><i v-if="itemSingle.price.smallText">{{itemSingle.price.smallText+' '}}</i><span>{{itemSingle.price.type=='gujia'?item.price.text:'****'}}</span></div>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-if="num==2">
                        <div class="classNameList">
                            <div @click="pitchClass(j)" class="classNameBox" :class="classNum==j?'classPitch':''" v-for="(itemClassName,j) in rankArtists" :key="j+'classNameBox'">
                                {{itemClassName.class_name}}
                            </div>
                        </div>
                        <template v-if="rankArtists.length>0">
                            <div class="listBox" v-for="(itemArtist,k) in rankArtists[classNum].list" @click="jumpArt(itemArtist)" :key="k+'rankSingle'">
                                <div class="imgBox">
                                    <img :src="itemArtist.crop_pic">
                                    <div class="topClasss" :class="'top'+(k+1)">TOP{{k+1 }}</div>
                                </div>
                                <div class="textBox">
                                    <div class="titleBox">{{ itemArtist.artist_name }}</div>
                                    <div class="descBox">{{ itemArtist.birth_day }}</div>
                                    <div class="descBox" style="margin-top:0.7rem">当前成交额 <i>{{' '+itemArtist.currency+' '}}</i><span>{{ itemArtist.current_price }}</span></div>
                                    <div class="descBox">总成交金额<i>{{' '+itemArtist.currency+' '}}</i><span>{{itemArtist.total_price}}</span></div>
                                </div>
                            </div>
                        </template>
                    </template>
                    <template v-if="num==1">
                        <div class="listBox" v-for="(itemCompany,k) in rankCompany" @click="jumpOrgan(itemCompany)" :key="k+'rankSingle'">
                            <div class="imgBox">
                                <img :src="itemCompany.crop_pic">
                                <div class="topClasss" :class="'top'+(k+1)">TOP{{k+1 }}</div>
                            </div>
                            <div class="textBox">
                                <div class="titleBox">{{ itemCompany.company_name }}</div>
                                <div class="descBox" style="margin-top:0.7rem">拍卖场次{{' '+itemCompany.auction_times }}</div>
                                <div class="descBox">总成交额<i>{{' '+itemCompany.currency+' '}}</i><span>{{itemCompany.deal_price}}{{itemCompany.Price_Unit}}</span></div>
                            </div>
                        </div>
                    </template>
                    <template v-if="num==3">
                        <div class="listBox" v-for="(itemHistory,k) in rankHistory" @click="jumpLot(itemHistory)" :key="k+'rankSingle'">
                            <div class="imgBox">
                                <img :src="itemHistory.coverPic">
                                <div class="topClasss" :class="'top'+(k+1)">TOP{{k+1 }}</div>
                            </div>
                            <div class="textBox">
                                <div class="titleBox">{{ itemHistory.show_title }}</div>
                                <div class="descBox">{{ itemHistory.date }}</div>
                                <div class="descBox" style="margin-top:0.7rem">{{ itemHistory.company }}</div>
                                <template v-if="isMem ==1">
                                    <div class="descBox"><i v-if="itemHistory.price.smallText">{{itemHistory.price.smallText+' '}}</i><span>{{itemHistory.price.text}}</span></div>
                                </template>
                                <template v-else>
                                    <div class="descBox"><i v-if="itemHistory.price.smallText">{{itemHistory.price.smallText+' '}}</i><span>{{itemHistory.price.type=='gujia'?item.price.text:'****'}}</span></div>
                                </template>

                            </div>
                        </div>
                    </template>

                </van-tab>
            </template>
        </van-tabs>
    </div>
</div>
</template>

<script>
import {
    indexRank
} from "@/api/index";
import {
    getMemType
} from "@/api/auction";
import {
    getWXConfig
} from "@/assets/js/weixinShare";
export default {
    components: {},
    data() {
        return {
            num: 0,
            classNum: 0,
            isMem: 0,
            appLinkShow: true,
            rankMenu: [],
            rankSingle: [],
            rankArtists: [],
            rankHistory: [],
            rankCompany: [],
            // 通链接数据
            appLink: '/2/8/0',
        }
    },
    methods: {
        getMemTypeFun() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember
                }
            })
        },
        pitchClass(e) {
            this.classNum = e;
        },
        jumpArt(item) {
            window.location.href = item.wap_url;
        },
        jumpOrgan(item) {
            this.$router.push({
                path: "/organ/" + item.organ_code,
            });
        },
        jumpLot(item) {
            window.location.href="https://m-auction.artron.net/trade/auction/detail/" + item.artCode;
            // this.$router.push({
            //     path: "/productdetail/" + item.artCode,
            // });
        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0)
        },
        changeTab(name) {
            // this.$router.push({
            //         path: "/rankList?active="+name
            //     });
            let newUrl = new URL(window.location.href)
            newUrl.searchParams.set('active', name)
            window.history.pushState(null, null, newUrl.href)
        },
        goBack() {
            if (document.referrer) {
                window.location.href = document.referrer
            } else if (window.history.state) {
                this.$router.back()
            } else if (this.$route.query.fromlink) {
                window.location.href = decodeURIComponent(this.$route.query.fromlink)
            } else {
                this.$router.push({
                    path: "/"
                });
            }
        },
        getBanks() {
            indexRank().then((res) => {
                if (res.code == 0) {
                    this.rankMenu = res.data.rank_top_menu
                    this.rankArtists = res.data.artist
                    // this.rankClasses = res.data.classes
                    this.rankCompany = res.data.company
                    this.rankHistory = res.data.history
                    this.rankSingle = res.data.single
                    // this.rankArtist = res.data.artist[0].list
                    // this.className = res.data.classes[0].class_name
                    this.num = Number(this.$route.query.active)
                    // let tabBox = document.getElementsByClassName("van-tabs__nav")[0];
                    // if (this.num > 1) {
                    //     console.log(tabBox.scrollLeft)
                    //     tabBox.scrollTo({
                    //         top: 100,
                    //         left: 100,
                    //         behavior: 'smooth'
                    //     });
                    //     console.log(tabBox.scrollLeft)
                    // }
                }
            });
        },
    },
    mounted() {

        // this.showWater = [1, 2].includes(Number(from))
        document.title = "排行榜 - 雅昌拍卖图录"
        this.getMemTypeFun()
        this.getBanks()
        window.AFedWxShareData = {
            title: "排行榜 - 雅昌拍卖图录APP",
            imgUrl: 'https://pubunder.artron.net/pubimgs/m/wxImgAuc.png',
            desc: "查看成交价，精览高清大图，尽在雅昌拍卖图录",
            link: window.location.href
        }
        getWXConfig(window.AFedWxShareData)

    }
}
</script>

<style lang="scss" scoped>
.page {
    .classNameList {
        width: 100%;
        overflow: auto;
        white-space: nowrap;

        .classNameBox {
            display: inline-block;
            background: rgba(0, 0, 0, 0.05);
            border-radius: 1rem;
            color: #6B6C6C;
            font-size: 0.6rem;
            padding: 0.4rem 0.6rem;
            margin: 0 0.3rem 1rem 0.3rem;

        }

        .classPitch {
            background: #000000;
            color: #FFFFFF;
        }
    }

    .listBox {
        width: 100%;
        margin: 0rem 0 1.4rem 0;

        .imgBox {
            width: 5rem;
            height: 5rem;
            border-radius: 0.5rem;
            margin-right: 0.6rem;
            overflow: hidden;
            display: inline-block;
            position: relative;

            img {
                width: 100%;
                height: 100%;
            }

            .topClasss {
                position: absolute;
                left: 0;
                top: 0;
                border-top-left-radius: 0.5rem;
                background: rgba(0, 0, 0, 0.3);
                color: #fff;
                text-align: center;
                font-size: 0.5rem;
                padding: 0.2rem 0.3rem;
            }

            .top1 {
                background: #FDCD12;
                color: #000;
            }

            .top2 {
                background: #C7C7C7;
                color: #000;
            }

            .top3 {
                background: #CD7E32;
            }
        }

        .textBox {
            width: calc(100% - 6rem);
            display: inline-block;
            margin-top: 0.3rem;
            vertical-align: top;

            .titleBox {
                font-size: 0.75rem;
                font-weight: 600;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

            }

            .descBox {
                margin-top: 0.1rem;
                font-size: 0.6rem;
                font-weight: 400;
                color: #949596;

                span {
                    font-weight: bold;
                    color: #000000;
                }
            }
        }
    }

    /deep/ #topHeader {
        .headerTop {
            box-shadow: none;
        }
    }

    .auctionList {
        width: 100%;
        background: #fff;

        /deep/ .van-tabs {
            width: 100%;

            .van-tabs__wrap {
                height: 1.8rem;
                width: 100%;

                .van-tabs__nav {
                    padding-left: .2rem;
                    padding-right: .2rem;
                    height: 2rem;
                    overflow: auto;

                    .van-tab {
                        flex: none;
                        margin: 0 .6rem;
                        padding: 0;

                        .van-tab__text {
                            font-size: 0.75rem;
                            font-family: SF Pro-Regular, SF Pro;
                            font-weight: 400;
                            color: #6B6C6C;
                            line-height: 0.75rem;
                        }

                        &.van-tab--active {
                            .van-tab__text {
                                font-size: 0.8rem;
                                font-weight: bold;
                                color: #000000;
                                line-height: 0.8rem;
                            }
                        }
                    }

                    .van-tabs__line {
                        width: 1.55rem;
                        height: 0.2rem;
                        background: -webkit-gradient(linear, left top, right top, from(#18A974), to(rgba(24, 169, 116, 0)));
                        background: linear-gradient(90deg, #18A974 0%, rgba(24, 169, 116, 0) 100%);
                        border-radius: 0;
                        opacity: 1;
                        bottom: 0.7rem;
                        left: -3.1rem;
                    }
                }
            }

            .van-tabs__content {
                padding: 0.5rem .8rem .8rem;
                position: relative;
                padding-bottom: calc(.8rem + constant(safe-area-inset-bottom));
                padding-bottom: calc(.8rem + env(safe-area-inset-bottom));

            }
        }
    }
}
</style>
